/**
 * Boot-time compatibility shim for old fragment-style links (`#agents`,
 * `#mcpconfig`, …) predating MS-740's path-based routes. Nothing in this app
 * produces an `href="#…"` link anymore — this exists purely so a stale
 * bookmark or a link pasted before the rename still lands somewhere sane.
 * See MS-740 T-URL-02.
 */
const LEGACY_HASH_ROUTES: Record<string, string> = {
  '#home': '/home',
  '#agents': '/agents',
  '#sparks': '/agents',
  '#mcpconfig': '/mcp',
  '#mambu-mcp': '/mcp',
  '#mcp': '/mcp',
  '#global-settings': '/global-settings',
  '#marketplace': '/marketplace',
  '#workflows': '/workflows',
  '#analytics': '/agents-analytics',
  '#agents-analytics': '/agents-analytics',
  '#mcp-analytics': '/mcp-analytics',
  '#audit-log': '/audit-log',
}

/** Returns the new path for a legacy hash fragment, or null if it doesn't match one. */
export function resolveLegacyHash(hash: string): string | null {
  return LEGACY_HASH_ROUTES[hash.toLowerCase()] ?? null
}
